import customAxios from "../api/interceptors";


export const getManagerKanbanService = (id?: number, order_by?: string, status?: number, per_page_count: number = 5, page: number = 1) => customAxios.get(`/company/${status === 300 ? 'manager' : 'viewer'}/kanban?order_by=${order_by}${id ? `&id=${id}` : ''}&per_page_count=${per_page_count}&page=${page}`);